/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AvailableActions {
    CREATE = 'CREATE',
    EDIT = 'EDIT',
    SUBMIT = 'SUBMIT',
    DELETE = 'DELETE'
}
